<h2 mat-dialog-title>
  {{ "components.specific-opening-times.title" | translate }}
</h2>
<mat-dialog-content class="content">
  <div class="days-container">
    @for (day of weekDays; track day) {
      <button
        mat-stroked-button
        [class.selected]="isSelected(day)"
        (click)="toggleDay(day)"
        class="day-button"
      >
        {{ ("enums.weekdays." + day | translate).substr(0, 2) }}
      </button>
    }
  </div>
  <mat-checkbox
    [(ngModel)]="checkboxWholeDayOpen"
    (ngModelChange)="checkboxWholeDayClose = false"
    >{{
      "components.specific-opening-times.open-whole-day-checkbox" | translate
    }}</mat-checkbox
  >
  <mat-checkbox
    [(ngModel)]="checkboxWholeDayClose"
    (ngModelChange)="checkboxWholeDayOpen = false"
    >{{
      "components.specific-opening-times.closed-whole-day-checkbox" | translate
    }}</mat-checkbox
  >
  @if (!checkboxWholeDayOpen && !checkboxWholeDayClose) {
    <div>
      <mat-card appearance="outlined">
        @for (
          intervalContainer of intervalContainers;
          track intervalContainer;
          let i = $index
        ) {
          <div class="interval-container">
            <mat-form-field appearance="fill">
              <mat-label>HH</mat-label>
              <input
                matInput
                id="opening-time-first-hh"
                aria-label="Start hour"
                #firstHH
                [(ngModel)]="intervalContainer.firsHH"
                (input)="onInput(firstHH, undefined, firstMM)"
                maxlength="2"
              />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>MM</mat-label>
              <input
                matInput
                id="opening-time-first-mm"
                aria-label="Start minute"
                #firstMM
                [(ngModel)]="intervalContainer.firstMM"
                (input)="onInput(firstMM, firstHH, secondHH)"
                maxlength="2"
              />
            </mat-form-field>
            <div class="separator">-</div>
            <mat-form-field appearance="fill">
              <mat-label>HH</mat-label>
              <input
                matInput
                id="opening-time-second-hh"
                aria-label="End hour"
                #secondHH
                [(ngModel)]="intervalContainer.secondHH"
                (input)="onInput(secondHH, firstMM, secondMM)"
                maxlength="2"
              />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>MM</mat-label>
              <input
                matInput
                id="opening-time-second-mm"
                aria-label="End minute"
                #secondMM
                [(ngModel)]="intervalContainer.secondMM"
                (input)="onInput(secondMM, secondHH, undefined)"
                maxlength="2"
              />
            </mat-form-field>
            <button
              mat-icon-button
              class="close-button"
              (click)="removeIntervalContainer(i)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
        <button mat-button (click)="addIntervalContainer()">
          {{
            "components.specific-opening-times.button-add-opening-times"
              | translate
          }}
        </button>
      </mat-card>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-button
    (click)="
      currentOpeningTimesService.setCurrentComponent({ type: 'overview' })
    "
  >
    {{ "components.specific-opening-times.button-abort" | translate }}
  </button>
  <button
    mat-button
    (click)="apply()"
    [disabled]="
      !checkboxWholeDayClose &&
      !checkboxWholeDayOpen &&
      !correctIntervalContainer
    "
  >
    {{ "components.specific-opening-times.button-save" | translate }}
  </button>
</mat-dialog-actions>
